import { InvitationCode, InvitationCodeFindParam, InviteHistory } from './../shared/model/invitation-code.model';

import axios from 'axios';

export class InvitationCodeService {
  private BASE_URL = 'api/invitation-code';

  public save(invitationCode: InvitationCode, headers?: any) {
    return axios.post(this.BASE_URL + '/save', invitationCode, { headers });
  }

  public search(findParam: InvitationCodeFindParam, page?: number, size?: number) {
    const params: any = {};
    if (findParam) {
      Object.keys(findParam).forEach(key => {
        if (findParam[key] !== undefined) {
          params[key] = findParam[key].toString().trim();
        }
      });
    }
    return axios.get(this.BASE_URL + '/search', { params: params });
  }

  public deleteById(id: string) {
    return axios.delete(this.BASE_URL + `/delete/${id}`);
  }

  public clearInviteeInCache() {
    return axios.delete(this.BASE_URL + '/deleteInvitee');
  }

  public getAllInvitee() {
    return axios.get(this.BASE_URL + '/getAllInvitee');
  }

  public saveAllInviteHistory(inviteHistory: InviteHistory[]) {
    return axios.post(this.BASE_URL + '/saveAllInviteHistory', inviteHistory);
  }

  public sendInvite(inviteHistory: InviteHistory) {
    return axios.post(this.BASE_URL + '/sendInvite', inviteHistory);
  }

  public getAllInviteHistory() {
    return axios.get(this.BASE_URL + '/getInviteHistory');
  }
}
